import { Component, OnInit,ViewChild,AfterViewInit } from '@angular/core';
import { LibraryService, Dropobj } from '../../services/library.service';

import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons, NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { AppGlobals } from '../../shared/app.global';

@Component({
  selector: 'app-ebooks',
  templateUrl: './ebooks.component.html',
  styleUrls: ['./ebooks.component.scss'],
  providers:[LibraryService],
})
export class EbooksComponent implements OnInit {

  
    bookdetails:any[];
    depts:any[];
    catgories:any[];
    suppliers:any[];
    publishers:any[];
    sources:any[];
    subjects:any[];
    author: Dropobj[];
   
    acctypes: any[];
    @ViewChild('dt') table: any;
    closeResult: string;
    modalOptions:NgbModalOptions;
    private modalRef: NgbModalRef;
    private smallmodalRef: NgbModalRef;
    booksmodel:any={};
    dashcount:any={};
    bookinfo:any={};
    oprtype:string;
    filtcatgory:any[];
    bindtypes:any[];
    laguages:any[];
    currency:any[];
    lsection=[];
    issuehis=[];
    ebkid:any;
    //=[{'id':'1','name':'English'},{'id':'2','name':'Hindi'}];
    tab=1;
    selcat:any=0;
    verifiedstatus:any;
    issuedetails:any={};
    bkcopies:any=1;
    statuses = [
      {value: 'Active', label: 'Active'},
      {value: 'Inactive', label: 'Inactive'},
     
    
    ];
    fileToUpload: File = null;
    fData: FormData = new FormData;
    //modalOption: NgbModalOptions = {};
    //filteredOptions: Observable<any[]>;
    constructor(private http: HttpClient, private liservice: LibraryService,private modalService: NgbModal,private _global: AppGlobals) {
  
      this.modalOptions = {
        backdrop:'static',
        backdropClass:'customBackdrop',
        size:'lg'
      }
     }
  
   
  
   
  
      
  
    ngOnInit(): void {
      this.getbookdetails();
      this.getdashcounts();
     
      this.getlibdepartment();
      this.getlibpublisher();
     
      this.getlibsubjects();
     
     
      this.getgenmasters('Language');
     
      
  
    }
    ngAfterViewInit()
    {
      
    }
    calcdisnetamt()
    {
      this.booksmodel.netamt=this.booksmodel.prate-(this.booksmodel.prate * (this.booksmodel.disc/100));
    }
    savebookdetails()
    {
  
  
      console.log('savedetails',this.booksmodel);
      this.liservice.savelibebook(this.booksmodel,this.oprtype)
  .subscribe(result => {
     alert(result.message);
     
  if(result.status=='Success')
  {
    let localmodref=this.modalRef;
  localmodref.close();
  //this.Refreshsummary();
  this.getbookdetails();
  
  }
  
  
  else{
  
  
  }
     
  
    
      
  }, error => alert('error in connection')
  );
    }
  
  
   
    getbookdetails() {
      this.liservice.getlibebooks()
          .subscribe(
          resultArray => {
              console.log('books-result', resultArray);
              this.bookdetails = resultArray;
             // this.authorfilter();
            //   this.author  = resultArray [
            //     {'author'}
            // ];
          },
          error => console.log("Error :: " + error)
          )
  }
  
  
  getdashcounts() {
    this.liservice.booksdashcounts()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.dashcount = resultArray[0];
           
        },
        error => console.log("Error :: " + error)
        )
  }
  
  getgenmasters(mastype) {
    //de
    var resuarr=[];
  return  this.liservice.getgenmasters(mastype)
        .subscribe(
        resultArray => {
            console.log('getgenmasters', resultArray);
            if(mastype=='Bindingtype')
            {
            this.bindtypes = resultArray;
            }
           else if(mastype=='Language')
            {
            this.laguages = resultArray;
            if (resultArray.length>0)
            {
            this.booksmodel.languageid=resultArray[0].id;
            }
            else
            {
              this.booksmodel.languageid='0';
            }
            }
           else if(mastype=='Currency')
            {
            this.currency = resultArray;
            if (resultArray.length>0)
            {
            this.booksmodel.currencyid=resultArray[0].id;
            }
            else
            {
              this.booksmodel.currencyid='0';
            }
            }
           
        },
        error => console.log("Error :: " + error)
        )
       
  }
 
  
  getlibsubjects() {
    this.liservice.getlibsubjects()
        .subscribe(
        resultArray => {
            console.log('getlibsubjects', resultArray);
            this.subjects = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }
  
 
  
  composefiltercategory(jstring)
  {
    var newstr = jstring.replace(/bkcatid/g, "value"); 
    var newstr = newstr.replace(/bkcatnm/g, "label"); 
    console.log('jsonrep',newstr);
    let resJSON = JSON.parse(newstr);
    var arr=Array.of(resJSON);
    let objval:any={};
    objval.label='All';
    objval.value='0';
    objval.status=0;
    arr[0].splice(0, 0, objval);
    this.filtcatgory=arr[0];
    console.log('filtcatgory',this.filtcatgory);
  }
  onChangefiltcat(selval)
  {
  debugger;
    //alert(selval);
  this.selcat=selval;
  }

  getlibpublisher() {
    this.liservice.getlibpublisher("selall")
        .subscribe(
        resultArray => {
            console.log('getlibpublisher', resultArray);
            this.publishers = resultArray;
            
        },
        error => console.log("Error :: " + error)
        )
  }
  getlibdepartment() {
    this.liservice.getlibdepartment()
        .subscribe(
        resultArray => {
            console.log('getlibdepartment', resultArray);
            this.depts = resultArray;
            
        },
        error => console.log("Error :: " + error)
        )
  }


  handleFileInput(files: FileList)
  {
      //console.log(e);
      this.fileToUpload = files.item(0);
  }

  upload(files: FileList) {
    debugger;
    this.fileToUpload = files.item(0);

    this.fData.append("bkid", this.ebkid.toString());
    //this.fData.append("docpurpose", "Studentphoto");

    // this.SService.uploadFile(fData).subscribe(
    //     response => this.handleResponse(response),
    //     error => this.handleError(error)
    // )
}


fileupload()
{
debugger
  
console.log('file data',JSON.stringify(this.fileToUpload));

  this.liservice.uploadebookFile(this.fileToUpload,this.ebkid)
  .subscribe(fresult => {
     // console.log('ret',JSON.stringify(fresult));
      alert (fresult.message);
      if(fresult.status=='Success')
{
  let localmodref=this.modalRef;
localmodref.close();
//this.Refreshsummary();
this.fileToUpload=null;
}
      
  }, error => 
  alert('error in connection')
  
  );
  

 
}

//   OnSubmit(Image) {
// //var enid=this.enid+'-'+this.orderid+'-'+this.cldata.dbname;
//      // this.myservice.uploadImage(enid,this.fileToUpload,this.secdoctypeid,this.cldata.schoolcode)
// .subscribe((result:any) => {


// }, error => {
// console.log('enqres',error);
// alert('error in connection')}
// );
      
//     }
  authorfilter()
  {
  var autharr=this.bookdetails;
    // this.author = autharr.filter(
    //   (thing, i, arr) => arr.findIndex(t => t.author === thing.author) === i
    // );
    var farr= Array.from(new Set(autharr.map((item: any) => item.author)));
   
    var auth=[];
    for(var i=0;i<farr.length;i++)
    {
      debugger
       let objval:Dropobj;
  objval.label=farr[i]
  objval.value=farr[i];
  console.log('obj',objval);
  auth.push(objval);
    }
  this.author=auth;
    console.log('auths',auth);
  //   this.statuses = [
  //     {label: 'Unqualified', value: 'unqualified'},
  //     {label: 'Qualified', value: 'qualified'},
  //     {label: 'New', value: 'new'},
  //     {label: 'Negotiation', value: 'negotiation'},
  //     {label: 'Renewal', value: 'renewal'},
  //     {label: 'Proposal', value: 'proposal'}
  // ]
  
  }
  applybooksFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
  
    if(filterValue.length>=3)
    {
      debugger
      
    this.liservice.serchbooks(filterValue,'serebook',0)
    .subscribe(
    resultArray => {
        console.log('books-result', resultArray);
        this.bookdetails = resultArray;
      // this.authorfilter();
        
    },
    error => console.log("Error :: " + error)
    )
  }
  else 
  {
    this.getbookdetails();
  }
  
  }
  
  openinfo(content,bkid)
  {
  
    this.ebkid=bkid;
    this.modalOptions={size:'sm'};
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         // this.Asmtdetls(asid);
          this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
  }
  openbookdialog(content,formdata,cmd) {
    debugger
    console.log("formdata",formdata);
    this.modalOptions={size:'lg'};
    this.oprtype=cmd;
    if(cmd=='insert')
    {
      this.booksmodel={};
      if (this.laguages.length>0)
      {
      this.booksmodel.languageid=this.laguages[0].id;
      }
      else
      {
        this.booksmodel.languageid='0';
      }
     
      this.booksmodel.ebkid=0;
     
      
      this.booksmodel.rstatus='Active';
    
      this.booksmodel.publisher='1';
      
      this.booksmodel.deptid='1';
     
      this.booksmodel.subjectid='1';
      
      
      this.booksmodel.author='';
      
      this.booksmodel.pubplace='';
      this.booksmodel.pubyr='';
      this.booksmodel.pages='0';
      this.booksmodel.edition='';
     
      this.booksmodel.title='';
      this.booksmodel.subtitle='';
     
  
  
      this.modalRef=this.modalService.open(content,this.modalOptions);
    
     this.modalRef.result.then((result) => {
    
          // this.Asmtdetls(asid);
           this.closeResult = `Closed with: ${result}`;
       }, (reason) => {
           this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
       });
    }
    else if (cmd=='update')
    {
      if(formdata.rstatus=='Active')
  {
      this.booksmodel=formdata;
      this.modalRef=this.modalService.open(content,this.modalOptions);
    
     this.modalRef.result.then((result) => {
    
          // this.Asmtdetls(asid);
           this.closeResult = `Closed with: ${result}`;
       }, (reason) => {
           this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
       });
  }
    }
    
    
      
    
  
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }
  
 

   getissueddetails(bookid) {
    this.liservice.getissuedbookdetails(bookid,'issuedbkdtks')
        .subscribe(
        resultArray => {
            console.log('issueddata', resultArray);
            this.issuedetails = resultArray[0];
          //issuedbktomem  
            
        },
        error => console.log("Error :: " + error)
        )
  }
  
  // getissuedhistory(bookid) {
  //   this.liservice.getissuedbookdetails(bookid,'issuedhistory')
  //       .subscribe(
  //       resultArray => {
  //           console.log('issuehis', resultArray);
  //           this.issuehis = resultArray;
            
            
  //       },
  //       error => console.log("Error :: " + error)
  //       )
  // }
  
  // openissuedhisdialog(content,bookid,obj) {
  //   debugger
  //   this.bookinfo=obj;
  //   this.getissuedhistory(bookid);
  //   this.modalOptions = {
  //     backdrop:'static',
  //     backdropClass:'customBackdrop',
      
     
  //   }
  //   this.modalRef=this.modalService.open(content,this.modalOptions);
    
  //   this.modalRef.result.then((result) => {
   
         
  //     }, (reason) => {
          
  //     });
  // }
  
  openissueddialog(content,bookid) {
    
    this.getissueddetails(bookid);
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      
     
    }
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }
  
  openbulkdialog(content) {
  
  
    
    
   var smallmodalOptions:NgbModalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'sm'
     
    }
    this.smallmodalRef=this.modalService.open(content,smallmodalOptions);
    
    this.smallmodalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }
  
  }
  